// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { FunctionOutput } from 'thehive-sdk';
import { classList } from '@Helpers/className';

import './FunctionListTitle.scss';

interface FunctionListTitleProps {
    data: FunctionOutput;
    onTitleClick?: () => void;
}

export const FunctionListTitle = ({ data, onTitleClick }: FunctionListTitleProps): ReactElement => {
    const { name, description } = data;

    return (
        <div className={classList('function-list-title', { clickable: !!onTitleClick })} onClick={onTitleClick}>
            <div className="function-list-title__title">
                <p className="function-list-title__title-name">{name}</p>
                <p className="function-list-title__title-description">{description}</p>
            </div>
        </div>
    );
};
